module.exports = __webpack_public_path__ + "static/media/icon-lamp-blue.d23f3c60.svg";